import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { LazyRoute } from './LazyRoute';

const ParentDashboard = lazy(() => import('@/features/parent/pages/ParentDashboard'));
const ChildrenListPage = lazy(() => import('@/features/parent/pages/ChildrenListPage'));
const ParentAssignmentsPage = lazy(() => import('@/features/parent/pages/ParentAssignmentsPage'));
const ChildDetailPage = lazy(() => import('@/features/parent/pages/ChildDetailPage'));
const SessionDetailPage = lazy(() => import('@/features/parent/pages/SessionDetailPage'));
const AssignmentDetailPage = lazy(() => import('@/features/parent/pages/AssignmentDetailPage'));
const ActivityDetailPage = lazy(() => import('@/features/parent/pages/ActivityDetailPage'));

export const parentRoutes = (
  <>
    <Route path="/parent" element={<LazyRoute fallbackMessage="Loading parent portal..."><ParentDashboard /></LazyRoute>} />
    <Route path="/parent/children" element={<LazyRoute fallbackMessage="Loading children..."><ChildrenListPage /></LazyRoute>} />
    <Route path="/parent/assignments" element={<LazyRoute fallbackMessage="Loading assignments..."><ParentAssignmentsPage /></LazyRoute>} />
    <Route path="/parent/child/:id" element={<LazyRoute><ChildDetailPage /></LazyRoute>} />
    <Route path="/parent/child/:id/activity/:itemType/:itemId" element={<LazyRoute><ActivityDetailPage /></LazyRoute>} />
    <Route path="/parent/child/:id/session/:sessionId" element={<LazyRoute><SessionDetailPage /></LazyRoute>} />
    <Route path="/parent/child/:id/assignment/:assignmentId" element={<LazyRoute><AssignmentDetailPage /></LazyRoute>} />
  </>
);
